/** @jsxImportSource @emotion/react */
import { useRef } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

import useScrollTop from '../../hooks/useScrollTop';
import Navigation from '../Navigation';
import SkipToMainButton from '../SkipToMainButton';

const Page = ({
  children,
  isBanner = 'false',
  showSkipLink,
  setShowSkipLink,
  skipCounter,
  setSkipCounter,
}) => {
  const pageRef = useRef();
  useScrollTop(pageRef);
  const location = useLocation();
  const currentPage =
    location.pathname === '/'
      ? 'homepage'
      : location.pathname.startsWith('/recommendations')
      ? 'recommendationspage'
      : location.pathname.startsWith('/club')
      ? 'clubpage'
      : location.pathname.startsWith('/team')
      ? 'teampage'
      : 'other';

  return (
    <div className="spa-scroll-top-fix" ref={pageRef} tabIndex={-1}>
      {(currentPage === 'homepage' ||
        currentPage === 'clubpage' ||
        currentPage === 'teampage') && (
        <>
          <div
            tabIndex={0}
            onFocus={() => setShowSkipLink(true)}
            style={{
              position: 'absolute',
              width: '1px',
              height: '1px',
              overflow: 'hidden',
            }}
          />
          <SkipToMainButton
            isVisible={showSkipLink}
            setIsVisible={setShowSkipLink}
            setSkipCounter={setSkipCounter}
            currentPage={currentPage}
          />
        </>
      )}
      <Navigation isBanner={isBanner} skipCounter={skipCounter} />
      {children}
    </div>
  );
};

export default Page;
